{
  "settingsPresenter": {
    "title": "Configuración – {{fboName}}",
    "newHangarName": "Nuevo hangar",
    "buttons": {
      "addHangar": "Añadir hangar"
    },
    "tabs": {
      "hangars": "Hangares",
      "ramps": "Rampas",
      "stackingSOPs": "Apilar SOPs",
      "towingEquipment": "Equipo de remolque",
      "estimation": "Estimación",
      "opsCenter": "Centro Ops",
      "teamMembers": "Equipo",
      "configuration": "Configuración",
      "reports": "Informes",
      "integrations": "Integraciones",
      "account": "Cuenta"
    }
  },
  "rampsSettings": {
    "rampEditor": {
      "properties": "Propiedades",
      "rampVersion": "Versión de Rampa",
      "v2Algorithm": "Algoritmo V2",
      "toolbar": {
        "selectSpotSize": "Seleccionar tamaño de lugar"
      }
    }
  }
}
